import type { DiaAgenda } from '@/pages/agenda/types';
import { formatarDiaCompleto } from '@/pages/agenda/utils';
import ItemAgenda from './ItemAgenda';

export default function BlocoDia({ dia }: { dia: DiaAgenda }) {
  const titulo = formatarDiaCompleto(dia.data);

  return (
    <section className="pt-6 pb-2">
      <div className="flex items-center gap-3 pb-3">
        <h3 className="whitespace-nowrap text-sm font-bold uppercase tracking-wide text-foreground-900">
          {titulo}
        </h3>
        <div className="h-px flex-1 bg-secondary-200" />
      </div>

      {dia.itens.length > 1 && (
        <div className="mb-2 inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-900">
          <span className="flex h-3.5 w-3.5 items-center justify-center">
            <i className="ri-calendar-2-line" />
          </span>
          {dia.itens.length} coisas marcadas neste dia
        </div>
      )}

      <div>
        {dia.itens.map((item, i) => (
          <ItemAgenda key={`${item.o_que}-${item.inicio_em}-${item.nome}-${i}`} item={item} />
        ))}
      </div>
    </section>
  );
}